import React from 'react'

const Benifitbox = () => {
  return (
    <div className="maincontainer relative overflow-x-clip pb-20 sm:pb-20 bg-blue-100">
        <div className="container sm:container mx-auto md:container md:auto">
            <div className="headlinesboix lg:pt-5 lg:pb-5  flex justify-center">
                <div className="biglines  mt-10">
                    <h1 className="fonting mx-auto text-center max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
                    What is TDS ?

                    </h1>
                    <div className="explainboxpara w-full mt-5 text-lg">
                    
                        <p>
                        Tax Deducted at Source, or TDS, is an additional indirect tax deduction scheme that is in accordance with the 1961 Taxation Act and is used to generate income. The payer withholds tax and sends it to the government on the recipient's behalf.

                        </p>
                    
                        <p className="mt-5 text-xl">
                        
A TDS Return could be a quarterly report that needs to be turned in to India's tax agency. If you are a deductor, you must submit your TDS return. Details of the TDS that you withheld and stored are included.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
          
    
  )
}

export default Benifitbox